import React, { useEffect, useState, useContext } from "react";

import OwlCarousel from 'react-owl-carousel';
import "./css/owl.carousel.min.css";
import "./css/owl.theme.default.min.css";



export const GalleryExt = (props) => {

    return (
        <>
            <div className="container-fluid px-0 bkg-ext">
                <div className="row">
                    <div className="col-12">
                        <OwlCarousel className='owl-carousel owl-theme'
                            loop={true}
                            nav={false}
                            responsiveClass={true}
                            responsive={{
                                0: {
                                    stagePadding: 25,
                                    items: 1,
                                    dots: false
                                },
                                992: {
                                    stagePadding: 250,
                                    items: 2,
                                    dots: true
                                },
                                2000: {
                                    stagePadding: 250,
                                    items: 3,
                                    dots: true
                                }
                            }}
                        >
                            <div>
                                <a href="images/Infynito80/carousel/ext/zoom/000001.jpg" data-fancybox="gallery-ext" data-caption="">
                                    <img src="images/Infynito80/carousel/ext/thumbs/000001.jpg" alt="" className="" />
                                </a>
                            </div>
                            <div>
                                <a href="images/Infynito80/carousel/ext/zoom/000002.jpg" data-fancybox="gallery-ext" data-caption="">
                                    <img src="images/Infynito80/carousel/ext/thumbs/000002.jpg" alt="" className="" />
                                </a>
                            </div>
                            <div>
                                <a href="images/Infynito80/carousel/ext/zoom/000003.jpg" data-fancybox="gallery-ext" data-caption="">
                                    <img src="images/Infynito80/carousel/ext/thumbs/000003.jpg" alt="" className="" />
                                </a>
                            </div>
                            <div>
                                <a href="images/Infynito80/carousel/ext/zoom/000004.jpg" data-fancybox="gallery-ext" data-caption="">
                                    <img src="images/Infynito80/carousel/ext/thumbs/000004.jpg" alt="" className="" />
                                </a>
                            </div>
                            <div>
                                <a href="images/Infynito80/carousel/ext/zoom/000005.jpg" data-fancybox="gallery-ext" data-caption="">
                                    <img src="images/Infynito80/carousel/ext/thumbs/000005.jpg" alt="" className="" />
                                </a>
                            </div>
                            <div>
                                <a href="images/Infynito80/carousel/ext/zoom/000006.jpg" data-fancybox="gallery-ext" data-caption="">
                                    <img src="images/Infynito80/carousel/ext/thumbs/000006.jpg" alt="" className="" />
                                </a>
                            </div>
                            <div>
                                <a href="images/Infynito80/carousel/ext/zoom/000007.jpg" data-fancybox="gallery-ext" data-caption="">
                                    <img src="images/Infynito80/carousel/ext/thumbs/000007.jpg" alt="" className="" />
                                </a>
                            </div>
                            <div>
                                <a href="images/Infynito80/carousel/ext/zoom/000008.jpg" data-fancybox="gallery-ext" data-caption="">
                                    <img src="images/Infynito80/carousel/ext/thumbs/000008.jpg" alt="" className="" />
                                </a>
                            </div>
                            <div>
                                <a href="images/Infynito80/carousel/ext/zoom/000009.jpg" data-fancybox="gallery-ext" data-caption="">
                                    <img src="images/Infynito80/carousel/ext/thumbs/000009.jpg" alt="" className="" />
                                </a>
                            </div>
                            <div>
                                <a href="images/Infynito80/carousel/ext/zoom/000010.jpg" data-fancybox="gallery-ext" data-caption="">
                                    <img src="images/Infynito80/carousel/ext/thumbs/000010.jpg" alt="" className="" />
                                </a>
                            </div>
                            <div>
                                <a href="images/Infynito80/carousel/ext/zoom/000011.jpg" data-fancybox="gallery-ext" data-caption="">
                                    <img src="images/Infynito80/carousel/ext/thumbs/000011.jpg" alt="" className="" />
                                </a>
                            </div>
                            <div>
                                <a href="images/Infynito80/carousel/ext/zoom/000012.jpg" data-fancybox="gallery-ext" data-caption="">
                                    <img src="images/Infynito80/carousel/ext/thumbs/000012.jpg" alt="" className="" />
                                </a>
                            </div>
                            <div>
                                <a href="images/Infynito80/carousel/ext/zoom/000013.jpg" data-fancybox="gallery-ext" data-caption="">
                                    <img src="images/Infynito80/carousel/ext/thumbs/000013.jpg" alt="" className="" />
                                </a>
                            </div>
                            <div>
                                <a href="images/Infynito80/carousel/ext/zoom/000014.jpg" data-fancybox="gallery-ext" data-caption="">
                                    <img src="images/Infynito80/carousel/ext/thumbs/000014.jpg" alt="" className="" />
                                </a>
                            </div>
                        </OwlCarousel>
                    </div>
                </div>
            </div >

        </>
    );
};

export default GalleryExt;